import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Input } from '@creditornot/cb-input';
import { Empty } from '@creditornot/cb-placeholders';
import { Modal, ModalHeader, ModalContent } from '@creditornot/cbt-modal';
import styled from 'styled-components';

export const SidepanelRoot = styled(Modal)``;

export const SidepanelHeader = styled(ModalHeader)``;

export const SidepanelContentComponent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SidepanelContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SidepanelToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

export const SidepanelToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
export const SidepanelToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SidepanelSearchInput = styled(Input)`
  width: 200px;
`;

export const SidepanelVenueList = styled.div`
  flex: 1 1 auto;
`;

export const SidepanelEmptyMessage = styled(Empty)`
  margin: 48px 16px;
`;
